import React from "react";
import { useSnackbar } from "notistack";
import { NotifyMode } from "./NotifyModeEnum";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { ReactComponent as WarningIcon } from "../../assets/svg/notify/warning.svg";
import { ReactComponent as ErrorIcon } from "../../assets/svg/notify/error.svg";
import { ReactComponent as SuccessIcon } from "../../assets/svg/notify/success.svg";

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: 364,
    borderRadius: 5,
    backgroundColor: "#fff",
  },
  [NotifyMode.SUCCESS]: {
    border: "solid 2px #3498db",
    boxShadow: "#aed6f1 8px 0px inset",
    "& .notify-icon": {
      color: "#3498db",
    },
  },
  [NotifyMode.WARNING]: {
    border: "solid 2px #e7c224",
    boxShadow: "#f5e7a7 8px 0px inset",
    "& .notify-icon": {
      color: "#e7c224",
    },
  },
  [NotifyMode.ERROR]: {
    border: "solid 2px #e74c3c",
    boxShadow: "#f5b7b1 8px 0px inset",
    "& .notify-icon": {
      color: "#e74c3c",
    },
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  iconTitleContainer: {
    padding: "14px 0px 0px 22px",
    display: "flex",
    alignItems: "flex-start",
  },
  iconContainer: {
    display: "inline-block",
  },
  titleContainer: {
    display: "inline-block",
    fontSize: 14,
    color: "#373737",
    marginLeft: 14,
  },
  content: {
    fontSize: 12,
    color: "#707070",
    padding: "0px 16px 16px 58px",
    whiteSpace: "pre-line",
    wordBreak: "break-word",
  },
  reset: {
    color: "#7f8c8d",
    width: 18,
    height: 18,
  },
}));

const SnackNotify = (key, title, content, mode, closeSnackbar) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.mainContainer, classes[mode])}>
      <div className={classes.headerContainer}>
        <div className={classes.iconTitleContainer}>
          <div className={classes.iconContainer}>
            {mode === NotifyMode.SUCCESS && <SuccessIcon />}
            {mode === NotifyMode.WARNING && <WarningIcon />}
            {mode === NotifyMode.ERROR && <ErrorIcon />}
          </div>
          <div className={classes.titleContainer}>{title}</div>
        </div>
        <IconButton onClick={() => closeSnackbar(key)}>
          <CloseIcon className={classes.reset} />
        </IconButton>
      </div>
      <div className={classes.content}>{content}</div>
    </div>
  );
};

export const useNotify = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  return (
    title: string = "Error",
    content: string = "Something went wrong",
    mode = NotifyMode.ERROR,
  ) => {
    return enqueueSnackbar("null", {
      anchorOrigin: { horizontal: "right", vertical: "top" },
      autoHideDuration: 7000,
      content: (key) => SnackNotify(key, title, content, mode, closeSnackbar),
    });
  };
};
